// src/Dashboard/pages/user/News/NewsDashboard.jsx

import React from "react";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import useScrollToTop from "../../../../hooks/useScollToTop";

import { useNewsDashboard } from "./hooks/useNewsDashboard";

import NewsHeader from "./components/NewsHeader";
import NewsKpis from "./components/NewsKpis";
import NewsToolbar from "./components/NewsToolbar";
import NewsCard from "./components/NewsCard";
import NewsSkeleton from "./components/NewsSkeleton";
import NewsEmptyState from "./components/NewsEmptyState";
import NewsDrawer from "./components/NewsDrawer";
import NewsReadDrawer from "./components/NewsReadDrawer";

export default function NewsDashboard() {
  useScrollToTop();

  const {
    user,
    isManager,

    newsList,
    filteredNews,
    visibleNews,
    loading,
    stats,

    ui,
    debouncedSearch,
    setDebouncedSearch,
    updateUi,
    resetFilters,
    loadMore,

    drawerOpen,
    drawerMode,
    currentNews,
    openCreateDrawer,
    openEditDrawer,
    closeDrawer,
    handleSaved,

    readDrawerOpen,
    readNews,
    openReadDrawer,
    closeReadDrawer,

    handleDeleteNews,
    refresh,
  } = useNewsDashboard();

  return (
    <section className="w-full pb-10 pt-5 font-satoshi">
      <div className="mx-auto max-w-[1900px] space-y-5 px-3 sm:px-4 lg:px-6">
        <NewsHeader
          loading={loading}
          isManager={isManager}
          onRefresh={refresh}
          onCreate={openCreateDrawer}
        />

        <NewsKpis stats={stats} loading={loading} isManager={isManager} />

        <section className="overflow-hidden rounded-[28px] border border-slate-200 bg-white shadow-sm dark:border-slate-800 dark:bg-slate-900">
          <div className="h-1.5 bg-gradient-to-r from-[#013E8E] via-indigo-500 to-[#4CA82F]" />

          <div className="p-4 sm:p-5 lg:p-6">
            <div className="flex flex-col gap-4 lg:flex-row lg:items-end lg:justify-between">
              <div>
                <p className="text-[11px] uppercase tracking-[0.22em] text-slate-500 dark:text-slate-400">
                  Vie du club
                </p>

                <h2 className="mt-1 text-xl font-bold text-slate-900 dark:text-white">
                  Actualités & résultats
                </h2>

                <p className="mt-2 max-w-3xl text-sm leading-6 text-slate-600 dark:text-slate-300">
                  Retrouvez les dernières informations, annonces, résultats de
                  compétition et communications importantes du club.
                </p>
              </div>

              <div className="rounded-2xl border border-slate-200 bg-slate-50 px-4 py-3 text-sm dark:border-slate-700 dark:bg-slate-800/60">
                <span className="text-slate-500 dark:text-slate-400">
                  Affichées :
                </span>{" "}
                <span className="font-bold text-slate-900 dark:text-white">
                  {filteredNews.length}
                </span>
                <span className="text-slate-500 dark:text-slate-400">
                  {" "}
                  / {newsList.length}
                </span>
              </div>
            </div>

            <div className="mt-5">
              <NewsToolbar
                ui={ui}
                updateUi={updateUi}
                debouncedSearch={debouncedSearch}
                setDebouncedSearch={setDebouncedSearch}
                isManager={isManager}
                onReset={resetFilters}
                onCreate={openCreateDrawer}
              />
            </div>

            {loading ? (
              <div className="mt-5 grid grid-cols-1 gap-4 lg:grid-cols-2">
                {Array.from({ length: 4 }).map((_, index) => (
                  <NewsSkeleton key={index} />
                ))}
              </div>
            ) : filteredNews.length === 0 ? (
              <NewsEmptyState
                isManager={isManager}
                onReset={resetFilters}
                onCreate={openCreateDrawer}
              />
            ) : (
              <>
                <div className="mt-5 grid grid-cols-1 gap-4 lg:grid-cols-2">
                  {visibleNews.map((news) => (
                    <NewsCard
                      key={news.id}
                      news={news}
                      canModify={isManager}
                      onRead={() => openReadDrawer(news)}
                      onEdit={() => openEditDrawer(news)}
                      onDelete={() => handleDeleteNews(news)}
                    />
                  ))}
                </div>

                {visibleNews.length < filteredNews.length && (
                  <div className="mt-6 flex justify-center">
                    <button
                      type="button"
                      onClick={loadMore}
                      className="rounded-2xl bg-[#013E8E] px-5 py-3 text-sm font-bold text-white transition hover:bg-indigo-800"
                    >
                      Charger plus
                    </button>
                  </div>
                )}
              </>
            )}
          </div>
        </section>
      </div>

      <NewsDrawer
        isOpen={drawerOpen}
        mode={drawerMode}
        news={currentNews}
        user={user}
        onClose={closeDrawer}
        onSaved={handleSaved}
      />

      <NewsReadDrawer
        isOpen={readDrawerOpen}
        news={readNews}
        onClose={closeReadDrawer}
      />

      <ToastContainer />
    </section>
  );
}
